import { EmailFonts } from '../../components/common/editor/Utilities.jsx';

const TypeConfig = {
    defaultBackgroundColor: '#333333',
    defaultFontFamily: 'helvetica,sans-serif',
    options: {
        alignment: () => ([
            { display: 'Left', value: 'left' },
            { display: 'Center', value: 'center' },
            { display: 'Right', value: 'right' }
        ]),
        fontFamily: () => (EmailFonts),
        measurement: (includePercent) => {
            const options = [{ display: 'PX', value: 'px' }];
            if (includePercent == true) {
                options.push({ display: '%', value: '%' });
            }
            return options;
        },
        valign: () => ([
            { display: 'Top', value: 'top' },
            { display: 'Middle', value: 'middle' },
            { display: 'Bottom', value: 'bottom' }
        ])
    }
}
export default TypeConfig;